import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=6d1811dc&scoped=true&"
import script from "./toolbar.vue?vue&type=script&lang=js&"
export * from "./toolbar.vue?vue&type=script&lang=js&"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=6d1811dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1811dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VToolbarItems})


/* vuetify-loader */
import installDirectives from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
installDirectives(component, {Resize})
